import type { IconData } from '@stacksjs/iconify-core'

export const dog: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m393.3 161.33l-58.768-84.892a48.09 48.09 0 0 0-38.775-20.673l-111.527-1.6H184c-57.579 0-101.757 9.631-130.21 56.634C27.3 154.551 16 229.08 16 360v16h36.557L29.024 496h32.61l23.533-120H96a99.52 99.52 0 0 0 70.088-27.992c16.979-16.246 29.226-38.472 35.419-64.274l.056-.232L229.006 152h-32.69l-25.979 124.488C162.425 309.168 138.766 344 96 344H48.06c.869-113.266 11.182-180.419 33.105-216.634c18.4-30.4 45.295-41.191 102.724-41.206l111.408 1.6a16.03 16.03 0 0 1 12.925 6.891L374.7 190.67l89.3 14.884v16.959l-14.892 79.421c-4.395 23.441-11.908 35.249-42.718 38.95l-126.306 21.609L279.249 496h32l.667-106.493l98.7-16.9c22.36-2.749 38.857-9.955 50.426-22.023c9.89-10.318 15.909-23.5 19.519-42.752L496 225.487v-47.041Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default dog
